import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  makeStyles,
} from "@material-ui/core";
import NavItemMenu from "./NavItemMenu";
import { RiHome2Line } from "react-icons/ri";
import { FiLogIn, FiClock } from "react-icons/fi";
import { FaRegImages } from "react-icons/fa";
import { BiHelpCircle, BiMailSend } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";
import { languages } from "../i18n/languagesUsed";
import ReactCountryFlag from "react-country-flag";

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px - 5%)",
    marginTop: "10%",
    position: "relative",
    zIndex: "0",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

const NavBarPublic = ({ onMobileClose, openMobile, user, items }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const changeLanguage = (lng) => {
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
  };

  const contentNavBar = (
    <Box display="flex" flexDirection="column">
      <Divider />

      <Box p={2}>
        <List>
          <NavItemMenu
            href={t("nav_menuburger.link_home")}
            title={t("nav_menuburger.home")}
            icon={RiHome2Line}
          />
          <NavItemMenu
            href={t("nav_menuburger.link_reserved_area")}
            title={t("nav_menuburger.reserved_area")}
            icon={FiLogIn}
          />

          <NavItemMenu
            href={t("nav_menuburger.link_products")}
            title={t("nav_menuburger.products")}
            icon={FiClock}
          />

          <NavItemMenu
            href={t("nav_menuburger.link_gallery")}
            title={t("nav_menuburger.gallery")}
            icon={FaRegImages}
          />

          <NavItemMenu
            href={t("nav_menuburger.link_support")}
            title={t("nav_menuburger.support")}
            icon={BiHelpCircle}
          />

          <NavItemMenu
            href={t("nav_menuburger.link_contact_us")}
            title={t("nav_menuburger.contact_us")}
            icon={BiMailSend}
          />

          <Divider />

          <Box display="flex" flexDirection="row">
            {languages.map((language, i) => {
              if (i18n.language !== language.key)
                return (
                  <Box m={1.5}>
                    <ReactCountryFlag
                      onClick={() => changeLanguage(language.key)}
                      countryCode={language.countryCode}
                      svg
                      style={{
                        width: "1.3em",
                        height: "1.3em",
                      }}
                      title={language.countryCode}
                    />
                  </Box>
                );
              return null;
            })}
          </Box>
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {contentNavBar}
        </Drawer>
      </Hidden>
    </>
  );
};

export default NavBarPublic;
